<!--begin::Notifications-->
<ng-template ngxPermissionsOnly="canSendMessage">
  <div
    ngbDropdown
    placement="bottom-right"
    autoClose="outside"
    class="dropdown dropdown-fluid"
    ngbTooltip="Notifications"
  >
    <!--begin::Toggle-->
    <div ngbDropdownToggle class="topbar-item" (click)="loadMessagesList()">
      <ng-container *ngIf="useSVG">
        <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary">
          <span class="svg-icon svg-icon-xl svg-icon-primary" [inlineSVG]="icon"></span>
          <span
            [matBadge]="unreadCount"
            matBadgeSize="medium"
            [matBadgeHidden]="false"
            matBadgeColor="warn"
            style="top: -8px"
          ></span>
          <span *ngIf="!hidden" class="pulse-ring bg-danger border-danger"></span>
        </div>
      </ng-container>
      <ng-container *ngIf="!useSVG">
        <i [ngClass]="icon"></i>
      </ng-container>
    </div>
    <!--end::Toggle-->

    <!--begin::Dropdown-->
    <div
      ngbDropdownMenu
      class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up show dropdown-notification"
    >
      <form>
        <!--begin::Header-->
        <div
          class="d-flex flex-column pt-7 pb-7 bp-10 bgi-size-cover bgi-no-repeat rounded-top header-notification"
        >
          <!--begin::Title-->
          <h4 class="d-flex flex-center rounded-top">
            <span class="text-dark">User Notifications</span>
          </h4>
        </div>

        <ngb-tabset #tab="ngbTabset" class="tab-content">
          <ngb-tab id="tab-id-1">
            <ng-template ngbTabContent>
              <div
                *ngIf="notifications.length !== 0"
                [perfectScrollbar]="{ wheelPropagation: false }"
                class="navi navi-hover scroll"
                [ngStyle]="{
                  height: '300px',
                  position: 'relative',
                  overflow: 'auto',
                  'overflow-x': 'hidden'
                }"
                (scroll)="onScroll($event)"
              >
                <!--begin::Nav-->
                <a class="navi-item" *ngFor="let item of notifications">
                  <div
                    class="navi-link"
                    (click)="viewMessage(item)"
                    [ngStyle]="{
                      display: 'flex',
                      'flex-direction': 'row-reverse',
                      'border-bottom': 'solid 1px #00000061',
                      'background-color': !item.is_completed ? '#EBEBEB61' : 'transparent',
                      'font-weight': !item.is_completed ? 'bold' : 'normal'
                    }"
                  >
                    <div>
                      <div class="navi-icon mr-2">
                        <span
                          class="svg-icon svg-icon-xl svg-icon-primary"
                          [inlineSVG]="getItem(item.is_completed)"
                        ></span>
                      </div>
                      <div class="dark-75" style="font-size: x-small; max-width: 40px">
                        {{ getDate(item.created) | date : 'MM-dd hh:mm a' }}
                      </div>
                    </div>
                    <div class="navi-text">
                      <div class="">{{ item.sender_name }}</div>
                      <div
                        class="dark-75"
                        style="
                          text-overflow: ellipsis;
                          overflow: hidden;
                          white-space: nowrap;
                          width: 95%;
                        "
                      >
                        {{ item.body | slice : 0 : 55 }}
                      </div>
                    </div>
                  </div>
                </a>
                <a class="navi-item load-more-label" *ngIf="!noMore"> Loading More... </a>
                <a class="navi-item load-more-label" *ngIf="noMore"> All caught up! </a>
                <!--end::Nav-->
              </div>
              <div
                *ngIf="notifications.length === 0"
                class="d-flex flex-center text-center text-muted"
                style="min-height: 200px"
              >
                All caught up!
                <br />No new notifications.
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </form>
    </div>
    <!--end::Dropdown-->
  </div>
</ng-template>
<!--end::Notifications-->
